import React from 'react'

const QueryBuilderContext = React.createContext({
  tagOptions: []
})

export default QueryBuilderContext
